"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoOrgTestnetCurrency = exports.CryptoOrgCurrency = exports.CryptoOrgAccountTransactionTypeEnum = void 0;
exports.CryptoOrgAccountTransactionTypeEnum = {
    MsgSend: "MsgSend",
    MgsMultiSend: "MsgMultiSend",
};
exports.CryptoOrgCurrency = "basecro";
exports.CryptoOrgTestnetCurrency = "basetcro";
//# sourceMappingURL=sdk.types.js.map